import React from 'react';
import PropTypes from 'prop-types';
import {
  PartnerLink, Picture
} from '@comicrelief/component-library';
import { getImage } from 'gatsby-plugin-image';

import { paddingOptionMapping } from '../../utils/optionMapping';
import ImagePropType from '../../commonPropTypes/commonPropTypes';
import {
  Container, Content, Category, List, ListItem, GroupTitle
} from './PartnersList.styles';

const Partners = ({ partnersList, data: { paddingAbove, paddingBelow } }) => {
  // Map the human-readable labels to the actual values, falling back to defaults:
  const paddingTop = paddingAbove ? paddingOptionMapping[paddingAbove] : '2rem';
  const paddingBottom = paddingBelow ? paddingOptionMapping[paddingBelow] : '2rem';

  const uniqueCategoriesList = Array.from(new Set(partnersList
    .map(({ node: { group } }) => group && group.title)));

  return (
    <Container paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Content data-test="partner-category-list">
        {uniqueCategoriesList.map(groupTitle => (
          groupTitle && (
          <Category key={groupTitle} data-test="partner-category">
            <GroupTitle tag="h2">
              {groupTitle}
            </GroupTitle>
            <List>
              {partnersList.map((partner) => {
                const {
                  id, path, name, logo, group
                } = partner.node;

                const thisImageData = getImage(logo);
                const thisImageFallback = thisImageData?.images?.fallback?.src;
                const thisImageSrcSet = thisImageData?.images?.sources[0]?.srcSet;
                const thisImageLow = thisImageData?.placeholder?.fallback;
                const isGroupEmpty = group && group.title;

                if (isGroupEmpty && groupTitle === group.title) {
                  return (
                    <ListItem key={id}>
                      <PartnerLink link={`/partners/${path}`}>
                        <Picture
                          alt={name}
                          image={thisImageFallback}
                          imageLow={thisImageLow}
                          images={thisImageSrcSet}
                          objectFit="cover"
                        />
                      </PartnerLink>
                    </ListItem>
                  );
                }
                return null;
              })}
            </List>
          </Category>
          )
        ))}
      </Content>
    </Container>
  );
};

Partners.propTypes = {
  data: PropTypes.shape({
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string
  }),
  partnersList: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        logo: ImagePropType.isRequired
      }).isRequired
    })
  ).isRequired
};

export default Partners;
